/**
 * Остатки сырья: первичный ввод и инвентаризация.
 *
 * Остаток — величина производная: он не правится напрямую, а пересчитывается
 * из регистра движений. Поэтому и первичный остаток, и итог инвентаризации —
 * это движения, а не запись нового числа поверх старого. Так любое расхождение
 * потом можно объяснить: видно, откуда взялась каждая тонна.
 *
 * Все количества — целые граммы. Килограммы существуют только на экране.
 */
import { z } from 'zod';
const dateField = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Дата в формате ГГГГ-ММ-ДД');
const quantityField = z.number().int('Количество в граммах, целым числом').min(0).max(1_000_000_000_000);
export const stockOpeningSchema = z.object({
    /** На какое число зафиксирован остаток. */
    at: dateField,
    lines: z
        .array(z.object({ materialTypeId: z.string().uuid(), qtyG: quantityField }))
        .min(1, 'Укажите хотя бы одну строку'),
});
export const stockInventorySchema = z
    .object({
    at: dateField,
    note: z.string().trim().max(1000).optional(),
    lines: z
        .array(z.object({ materialTypeId: z.string().uuid(), countedQtyG: quantityField }))
        .default([]),
    /** Готовая продукция считается штуками и в том же пересчёте. */
    productLines: z
        .array(z.object({
        productSizeId: z.string().uuid(),
        countedQtyPieces: z.number().int().min(0).max(10_000_000),
    }))
        .default([]),
})
    .refine((value) => value.lines.length > 0 || value.productLines.length > 0, {
    message: 'Укажите хотя бы одну строку',
});
//# sourceMappingURL=stock.js.map